import { InputHTMLAttributes, type JSX } from 'react';
import { CustomElement } from 'react-hook-form';

interface ICheckbox extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  required: boolean;
  register?: (
    ref: HTMLInputElement | HTMLTextAreaElement | CustomElement<any> | null,
  ) => void;
  id: string;
  defaultChecked?: boolean;
  value?: string;
  dataTestId?: string;
}

const Checkbox = ({
  name,
  required,
  register,
  id,
  defaultChecked,
  value,
  dataTestId,
  ...props
}: ICheckbox): JSX.Element => {
  return (
    <>
      <input
        type="checkbox"
        name={name}
        ref={register}
        required={required}
        id={id}
        defaultChecked={defaultChecked}
        value={value}
        data-testid={dataTestId}
        {...props}
      />
      <style jsx>{`
        input {
          appearance: none;
          -webkit-appearance: none;
          cursor: pointer;
          width: 24px;
          height: 24px;
          position: relative;
          box-shadow: none;
        }

        input:after {
          border: 2px solid
            ${props.disabled
              ? 'var(--clr-checkbox-disabled)'
              : 'var(--clr-checkbox-border)'};
          position: absolute;
          inset: 0;
          content: ' ';
          background-color: var(--white);
          display: inline-block;
          visibility: visible;
          border-radius: 4px;
          transition: all 0.3s;
        }

        input:checked:after {
          border: 2px solid
            ${props.disabled
              ? 'var(--clr-checkbox-disabled)'
              : 'var(--clr-checkbox-border)'};
          background-color: ${props.disabled
            ? 'var(--clr-primary-3)'
            : 'var(--clr-primary-1)'};
          box-shadow: inset 0 0 0px 2.5px #fff;
        }
      `}</style>
    </>
  );
};

export default Checkbox;
